import { Atom } from 'AppReact';
import GoogleAutocomplete from 'react-google-places-autocomplete';


export default Atom({ type: 'custom', dataType: 'string', template: GoogleAutocomplete });
